import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { Auth } from '@mdlinx/shared';
import URLSearchParams from '@ungap/url-search-params';

import { RecoverEmailHandler } from './RecoverEmailHandler';
import { ResetPasswordHandler } from './ResetPasswordHandler';
import { VerifyEmailHandler } from './VerifyEmailHandler';
import { SignInWithOobCode } from './SignInWithOobCodeHandler';

const OnError: React.FC<{ message: string }> = ({ message }) => {
  // TODO:
  return <div>{message}</div>;
};

function sendMessage(message: Auth.LoginResult) {
  if (window.parent) {
    window.parent.postMessage(message, '*');
  }
}

export const EmailActionHandler: React.FC<RouteComponentProps<any>> = ({ location, history }) => {
  const params = new URLSearchParams(location.search);
  const mode = params.get('mode');
  const oobCode = params.get('oobCode');
  const parentUrl = params.get('parentUrl') ?? '';

  if (!oobCode) {
    return <OnError message={'Invalid request'} />;
  }

  switch (mode) {
    case 'resetPassword':
      return (
        <ResetPasswordHandler
          oobCode={oobCode}
          onSuccess={() => history.push('/login/help/password-reset-confirmation')}
          onClickBack={() => history.push('/login')}
        />
      );
    case 'recoverEmail':
      return <RecoverEmailHandler oobCode={oobCode} onSuccess={() => sendMessage(Auth.loginSucceeded)} />;
    case 'verifyEmail':
      return <VerifyEmailHandler oobCode={oobCode} onSuccess={() => sendMessage(Auth.loginSucceeded)} />;
    case 'signIn':
      return (
        <SignInWithOobCode
          onSuccess={() => sendMessage(Auth.loginWithLinkSucceeded)}
          onClickBack={() => history.push('/login')}
          parentUrl={parentUrl}
        />
      );
    default:
      return <OnError message={'Invalid request'} />;
  }
};
